import { useState } from 'react'
import { Link } from 'react-router-dom'
import './nav.scss'
import Logo from '../logo/Logo'

const Nav = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false)

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen)
  }

  return (
    <nav className='nav'>
      <Link to='/' className='nav__logo'>
        <Logo />
      </Link>

      <button
        className='nav__hamburger'
        onClick={toggleMenu}
        aria-label="Toggle navigation menu"
        aria-expanded={isMenuOpen}
      >
        <span></span>
        <span></span>
        <span></span>
      </button>

      <ul className={`nav__links ${isMenuOpen ? 'nav__links--open' : ''}`}>
        <li>
          <Link to='/' onClick={() => setIsMenuOpen(false)}>Scale Viewer</Link>
        </li>
        <li>
          <Link to='/scale-finder' onClick={() => setIsMenuOpen(false)}>Scale Finder</Link>
        </li>
        {/* <li>
          <Link to='/'>Chords</Link>
        </li> */}
      </ul>
    </nav>
  )
}

export default Nav